import { Component, OnInit } from '@angular/core';
import { PworkflowComponent } from '../index';
import { ServiceInterface } from 'services/service.interface';
import { stateConstant } from '../../../../constants';
import { Register, AreaFocus, StudyState, Questions } from '../../../models';
import * as sha1 from 'sha1';

declare var $:any;

@Component({
  selector: 'login',
  templateUrl: 'login.component.html'
})

export class LoginComponent implements OnInit {
  states: any[] = stateConstant;
  formClass: string = "";
  errormsg: any[] = new Array();
  errdisplay:boolean= false;
  login: Register = new Register();

  constructor(private _services: ServiceInterface, public _parent: PworkflowComponent){}

  async ngOnInit() {
    this._parent.model = new Questions();
  }

  clickSubmit(valid){
    this.errormsg = [];
    if(valid){
      this.loginsubmit();
    }else{
      if($('#username-text').val() == ""){
        this.errdisplay = true;
        this.errormsg.push("Please enter username.");
      }
      if($('#password-text').val() == ""){
        this.errdisplay = true;
        this.errormsg.push("Please enter password.");
      }
      this.formClass = "validate";
    }
  }

  async loginsubmit() {
    this.errormsg = [];
    let logininfo = {
      'uname': this.login.uname,
      'password':sha1(this.login.password)
    }
    let loginData = await  this._services.post('/authenicate/login',logininfo);
    if(loginData.length == 1 && loginData[0].type == "user"){
      this._parent.loginAction(loginData[0].uuid);
    }else{
      if(loginData == "emailnotexist"){
        this.errdisplay = true;
        this.errormsg.push("User does not exist.");
      }else if(loginData == "wrongpassword"){
        this.errdisplay = true;
        this.errormsg.push("Wrong Password.");
      }else{
        this.errdisplay = true;
        this.errormsg.push("Invalid Login Information.");
      }
    }
    //console.log("DD:",loginData);
  }

  searchData(){
    this._parent.index=1;
  }

}


// WEBPACK FOOTER //
// ./src/app/components/pworkflow/login/login.component.ts